import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Bell, UserPlus, Trophy, MessageSquare, Check, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import api from "../lib/api";

const NOTIFICATION_ICONS = {
  follow: UserPlus,
  league_invite: Trophy,
  week_result: Trophy,
  message: MessageSquare,
};

export default function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.getNotifications();
        setNotifications(response.data);
        
        // Mark as read
        await api.markNotificationsRead();
      } catch (error) {
        console.error("Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("tr-TR", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="w-8 h-8 text-[#4DFFFF] animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-testid="notifications-page">
      <div className="mb-8">
        <h1 className="text-3xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider text-white">
          Bildirimler
        </h1>
        <p className="text-[#B1C1C1] mt-1">Tüm aktiviteleriniz</p>
      </div>

      <div className="glass-card overflow-hidden">
        {notifications.length === 0 ? (
          <div className="p-8 text-center">
            <Bell className="w-12 h-12 text-[#64748B] mx-auto mb-4" />
            <p className="text-[#B1C1C1]">Henüz bildirim yok</p>
          </div>
        ) : (
          <div className="divide-y divide-white/5">
            {notifications.map((notification) => {
              const Icon = NOTIFICATION_ICONS[notification.type] || Bell;
              return (
                <div
                  key={notification.notification_id}
                  className={`p-4 hover:bg-white/5 transition-colors ${
                    !notification.is_read ? "bg-[#4DFFFF]/5" : ""
                  }`}
                >
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-[#4DFFFF]/20 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-[#4DFFFF]" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-medium text-white">{notification.title}</p>
                      <p className="text-sm text-[#B1C1C1] mt-1">{notification.message}</p>
                      <p className="text-xs text-[#64748B] mt-2">{formatDate(notification.created_at)}</p>
                    </div>
                    {!notification.is_read && (
                      <div className="w-2 h-2 rounded-full bg-[#4DFFFF]" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
